import { AppKind, TellentClientBootstrapDataV2, TellentClientConfig } from '@core/tellent-types';

import { setupClient } from './demo-client-setup';
import { TellentClient } from '../app/tellent-client';

export const demoApp = (
  appKind: AppKind,
  config: TellentClientConfig,
  dataCallback: (data: Partial<TellentClientBootstrapDataV2> | null | void) => void,
) => {
  const client = new TellentClient(config);

  client
    .initWithSelfAuth(appKind)
    .then(data => {
      dataCallback(data);
      setupClient(client, data, appKind);
    })
    .catch(err => {
      console.error(err);
    });

  return client;
};
